import { render, staticRenderFns } from "./LegalEntitiesForm.vue?vue&type=template&id=070613c2&scoped=true&"
import script from "./LegalEntitiesForm.vue?vue&type=script&lang=js&"
export * from "./LegalEntitiesForm.vue?vue&type=script&lang=js&"
import style0 from "./LegalEntitiesForm.vue?vue&type=style&index=0&id=070613c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070613c2",
  null
  
)

export default component.exports